import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "sort"
})
export class ArraySortPipe implements PipeTransform {
  transform(array: any, field: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    
    array.sort((a: any, b: any) => {
      var aVal = a[field]; var bVal = b[field]; 
      if (field.indexOf('.') != -1) {
        aVal = a[field.split('.')[0]];
        aVal = aVal[field.split('.')[1]];
        bVal = b[field.split('.')[0]];
        bVal = bVal[field.split('.')[1]];
      } 
      if (aVal < bVal) {
        return -1;
      } else if (aVal > bVal) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}
